module.exports = __webpack_public_path__ + "static/media/optimma-logo.55954c0a.svg";